export const GRID_ROW_HEIGHT = 100; /* px */
export const GRID_NUMBER_OF_COLS = 12; /* block */
export const HEATMAP_TABLE_ROW_HEIGHT = 44; /* px */
